// #region =========== 浏览器运行环境
let host = `${window.location.protocol}//${window.location.hostname}`; // 当前浏览器访问的主机名，带 http(s) 协议

let isLocalDevEnv = false;
if (window.location.hostname == "localhost") {
  isLocalDevEnv = true;
  host = "https://bihai.top";
}

const baseApiUrl = `${host}/api`; // 用于 fetch api
// #endregion

// #region =========== 体验店登录
// 体验店登录入口清单；unionid 只保存在 bhserver/env.js 后端源头清单。
const sampleChains = [
  {
    name: "零售体验店",
    chainId: "699c182342a38e0567ab9a4d",
  },
  {
    name: "美发体验店",
    chainId: "69e825bfd026dbcbb026c19c",
  },
  {
    name: "宠物店专业版测试店",
    chainId: "6a6201114597d44aac4746d1",
  },
  {
    name: "宠物店标准版测试店",
    chainId: "6a62f53b50858553f53cd76d",
  },
  {
    name: "中餐馆专业版测试店",
    chainId: "6a619baabf9ced357cc4a89c",
  },
  {
    name: "茶饮体验店",
    chainId: "691d7571f0b1d158f829f6a1",
  },
  {
    name: "烘焙体验店",
    chainId: "691d74cdf0b1d158f829f697",
  },
  {
    name: "餐饮体验店",
    chainId: "69759feec049903648189464",
  },
];

if (isLocalDevEnv || window.location.hostname === "bihai.top") {
  sampleChains.push({ name: "生鲜体验店", chainId: "6aafe0d8e76170bae29ae13c" });
}

const SAMPLE_ID_MAP = Object.fromEntries(
  sampleChains.map((sample) => [sample.name, sample])
);

const getSampleLogin = (sampleName) => {
  const sample = SAMPLE_ID_MAP[sampleName];
  return sample ? { name: sampleName, ...sample } : null;
};
// #endregion

// #region =========== 前端门店类型分组 FRONTEND_TYPE_GROUP
// 由 bhserver/env.js 生成。页面直接通过 env.shopType 使用，不在页面中散写行业数组。
const FRONTEND_TYPE_GROUP = {
  inventoryTypes: ["store", "stationery", "petstore"],
  retailHardwareTypes: ["store", "stationery", "fresh"],
  productSpecTypes: ["cafe", "bakery", "fastfood"],
  foodOrderTypes: ["cafe", "bakery", "fastfood"],
  diningModeTypes: ["fastfood"],
  appointmentTypes: ["barber", "spa", "massage", "housekeeping", "repair", "petstore"],
  serviceOnlyTypes: ["massage", "housekeeping", "repair"],
  serviceAndGoodsTypes: ["barber", "spa", "petstore"],
  goodsOnlyTypes: ["store", "stationery", "fresh", "cafe", "bakery", "fastfood"],
  kitchenPrintTypes: ["fastfood"],
  cupLabelTypes: ["cafe"],
  noAndroidPosTypes: ["pro-apparel"],
  pendingOrderTypes: ["cafe", "store", "stationery", "fresh"],
  releasedTypes: ["store", "stationery", "fresh", "housekeeping", "repair", "cafe", "bakery", "fastfood", "barber", "spa", "massage", "petstore"],
};

const SHOP_TYPE_KEYS = [
    "store",
    "stationery",
    "fresh",
    "cafe",
    "bakery",
    "fastfood",
    "barber",
    "spa",
    "massage",
    "housekeeping",
    "repair",
    "petstore",
  ];

const SHOP_TYPE_SET = new Set(SHOP_TYPE_KEYS);
const TARGET_SHOP_TYPES = SHOP_TYPE_SET;

const normalizeShopType = (type) => {
  const value = String(type || "").trim().toLowerCase();
  if (value.startsWith("pro-") || value.startsWith("elephant-")) return value;
  return value.replace(/[_-]/g, "");
};

const resolveShopType = (shopOrType = {}) => {
  if (typeof shopOrType === "string") return normalizeShopType(shopOrType);
  return normalizeShopType(shopOrType?.chain?.type || shopOrType?.type);
};

const isTypeInGroup = (shopOrType, groupName) => {
  const group = FRONTEND_TYPE_GROUP[groupName] || [];
  return group.includes(resolveShopType(shopOrType));
};

const isFoodOrderType = (shopOrType) =>
  isTypeInGroup(shopOrType, "foodOrderTypes");
const isRetailHardwareType = (shopOrType) =>
  isTypeInGroup(shopOrType, "retailHardwareTypes");
const isProductSpecType = (shopOrType) =>
  isTypeInGroup(shopOrType, "productSpecTypes");
const isDiningModeType = (shopOrType) =>
  isTypeInGroup(shopOrType, "diningModeTypes");
const isAppointmentType = (shopOrType) =>
  isTypeInGroup(shopOrType, "appointmentTypes");
const isKitchenPrintType = (shopOrType) =>
  isTypeInGroup(shopOrType, "kitchenPrintTypes");
const isCupLabelType = (shopOrType) =>
  isTypeInGroup(shopOrType, "cupLabelTypes");
const isNoAndroidPosType = (shopOrType) =>
  isTypeInGroup(shopOrType, "noAndroidPosTypes");

const applyFrontendTypeGroupConfig = (config = {}) => {
  const nextGroup = config.frontendTypeGroup;
  if (!nextGroup || typeof nextGroup !== "object") return false;

  const nextKeys =
    config.shopTypeKeys ||
    config.shopTypes?.map?.(({ type }) => type) ||
    nextGroup.allTypes ||
    [];

  Object.keys(FRONTEND_TYPE_GROUP).forEach((key) => {
    delete FRONTEND_TYPE_GROUP[key];
  });
  Object.entries(nextGroup).forEach(([key, value]) => {
    if (key !== "allTypes" && Array.isArray(value)) FRONTEND_TYPE_GROUP[key] = value;
  });

  SHOP_TYPE_KEYS.splice(0, SHOP_TYPE_KEYS.length, ...nextKeys);
  SHOP_TYPE_SET.clear();
  SHOP_TYPE_KEYS.forEach((type) => SHOP_TYPE_SET.add(type));
  return true;
};

const loadShopTypeConfig = async (baseApiUrl, timeoutMs = 2500) => {
  if (!baseApiUrl) return false;
  const url = `${baseApiUrl}/config/shopTypeConfig`;

  try {
    if (typeof fetch === "function") {
      const controller =
        typeof AbortController !== "undefined" ? new AbortController() : null;
      const timer = controller
        ? setTimeout(() => controller.abort(), timeoutMs)
        : null;
      try {
        const response = await fetch(url, {
          credentials: "include",
          signal: controller?.signal,
        });
        const data = await response.json();
        return applyFrontendTypeGroupConfig(data);
      } finally {
        if (timer) clearTimeout(timer);
      }
    }

    if (typeof wx !== "undefined" && wx.request) {
      return await new Promise((resolve) => {
        let settled = false;
        const finish = (value) => {
          if (settled) return;
          settled = true;
          resolve(value);
        };
        const timer = setTimeout(() => finish(false), timeoutMs);
        wx.request({
          url,
          method: "GET",
          success: (res) => finish(applyFrontendTypeGroupConfig(res.data || {})),
          fail: () => finish(false),
          complete: () => clearTimeout(timer),
        });
      });
    }
  } catch (error) {
    console.warn("加载门店类型配置失败，继续使用本地配置", error);
  }

  return false;
};

const shopType = {
  FRONTEND_TYPE_GROUP,
  SHOP_TYPE_KEYS,
  SHOP_TYPE_SET,
  TARGET_SHOP_TYPES,
  normalizeShopType,
  resolveShopType,
  isTypeInGroup,
  isFoodOrderType,
  isRetailHardwareType,
  isProductSpecType,
  isDiningModeType,
  isAppointmentType,
  isKitchenPrintType,
  isCupLabelType,
  isNoAndroidPosType,
  applyFrontendTypeGroupConfig,
  loadShopTypeConfig,
};
// #endregion 前端门店类型分组

// #region =========== 导出对象 env
const env = {
  host, // 用于 data 静态资源
  baseApiUrl, // 用于 fetch api
  isLocalDevEnv, // 是否 localhost 调试
  FRONTEND_TYPE_GROUP,
  shopType,
  sampleChains,
  SAMPLE_ID_MAP,
  getSampleLogin,
};

export default env;
// #endregion
